const OrderActionType = {
    REGISTER_ORDER_REQUEST:'REGISTER_ORDER_REQUEST',
    REGISTER_ORDER_SUCCESS:'REGISTER_ORDER_SUCCESS',
    REGISTER_ORDER_FAIL:'REGISTER_ORDER_FAIL',

    UNREGISTER_ORDER_REQUEST:'UNREGISTER_ORDER_REQUEST',
    UNREGISTER_ORDER_SUCCESS:'UNREGISTER_ORDER_SUCCESS',
    UNREGISTER_ORDER_FAIL:'UNREGISTER_ORDER_FAIL',


    ORDER_REQUEST:'ORDER_REQUEST',
    ORDER_SUCCESS:'ORDER_SUCCESS',
    ORDER_FAIL:'ORDER_FAIL',


}


export default OrderActionType